module.exports = __webpack_public_path__ + "img/login-barriorojas.a7661995.svg";